import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { Movie } from '../../../services/Page/page.service';
import { AuthService } from '../../../services/Auth/auth.service';

@Component({
    selector: 'app-add-large',
    imports: [
        CommonModule,
        MatIconModule
    ],
    templateUrl: './add-large.component.html',
    styleUrl: './add-large.component.scss'
})
export class AddLargeComponent {
    private _movie!: Movie;
    @Input('movie')
    public get movie(): Movie {
        return this._movie;
    }
    public set movie(value: Movie) {
        this._movie = value;

        if(this.movie!=undefined) {
            this.authService.wishList$.subscribe((wishList) => {
                this.isInWishlist = wishList.includes(this.movie.Dx)
            })
        }

    }

    public isInWishlist: boolean = false

    constructor(
        public authService: AuthService
    ) {
        
    }

    onClick() {
        if (!this.isInWishlist) {
            this.authService.addToWishList(this.movie.Dx, this.movie);
        }
        else {
            this.authService.removeFromWishlist(this.movie.Dx)
        }
    }
}
